import React, { useState, useEffect } from "react";
import NoAuthFooter from "../../components/NoAuthFooter";
import { kvkkPolicy } from "../../api/kvkkPolicyServices";

export default function KvkkPolicy() {
  const [kvkkPolicyData, setKvkkPolicyData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchKvkkPolicy = async () => {
      try {
        setLoading(true);
        const response = await kvkkPolicy.getByToken();

        const data = response?.data?.data || response?.data;
        if (data) {
          setKvkkPolicyData(data);
        }
      } catch (error) {
        console.error("KVKK politikası çekilirken hata oluştu:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchKvkkPolicy();
  }, []);

  const htmlContent =
    typeof kvkkPolicyData === "string"
      ? kvkkPolicyData
      : kvkkPolicyData?.content || "";

  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 antialiased flex flex-col">
      <main className="grow max-w-3xl w-full mx-auto px-4 sm:px-6 py-10">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 sm:p-10">
          <div className="mb-6 pb-4 border-b border-slate-100">
            <h1 className="text-2xl font-bold text-slate-900 mb-1">
              {kvkkPolicyData?.title ||
                "Kişisel Verilerin Korunması Politikası"}
            </h1>
          </div>

          {loading ? (
            <div className="flex justify-center items-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-900"></div>
            </div>
          ) : htmlContent ? (
            <div
              className="policy-html-content text-slate-600 text-sm leading-6"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
          ) : (
            <div className="text-center py-12 text-slate-500 text-sm">
              KVKK metni yüklenemedi veya henüz eklenmedi.
            </div>
          )}

          <div className="mt-8 pt-6 border-t border-slate-100 text-center">
            <p className="text-xs text-slate-400 font-medium">
              © 2026 Tuncay Seyahat. Tüm Hakları Saklıdır.
            </p>
          </div>
        </div>
      </main>

      <NoAuthFooter />

      <style>{`
        .policy-html-content h1 {
          color: #0f172a;
          font-size: 1.25rem;
          font-weight: 700;
          margin-bottom: 1rem;
          text-align: center;
        }
        .policy-html-content h2 {
          color: #1e293b;
          font-size: 0.9375rem;
          font-weight: 700;
          margin-top: 1.25rem;
          margin-bottom: 0.5rem;
        }
        .policy-html-content h3 {
          color: #1e293b;
          font-size: 0.875rem;
          font-weight: 700;
          margin-top: 1rem;
          margin-bottom: 0.5rem;
        }
        .policy-html-content p {
          margin-bottom: 0.75rem;
          text-align: justify;
          color: #475569;
        }
        .policy-html-content strong {
          color: #1e293b;
          font-weight: 700;
        }
        .policy-html-content a {
          color: #2563eb;
          text-decoration: underline;
          font-weight: 500;
        }
        .policy-html-content ul {
          padding-left: 1.25rem;
          margin-bottom: 0.75rem;
          list-style-type: disc;
        }
        .policy-html-content li {
          margin-bottom: 0.375rem;
        }
      `}</style>
    </div>
  );
}
